import React from 'react'
import ReactDOM from 'react-dom'
import analytics from 'utils/analytics'
import './index.scss'
import 'global/style-config/fonts.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'

analytics.init()

ReactDOM.render(<App />, document.getElementById('root'))

serviceWorker.unregister()
